<template>
<div>
    <jet-form-section>
        <template #title>
            PIN para transações no aplicativo móvel
        </template>

        <template #description>
            É necessário um PIN de 6 digitos para concluir transações financeiras no app.
            <div class="md:col-span-6 sm:col-span-12 pl-5">
            </div>
        </template>

        <template #form>
            <div class="col-span-3 pt-6">
                <jet-label for="password" value="Novo PIN" />
                <jet-input id="password" type="password" class=" w-3/4 form-input rounded-md border border-solid border-black text-gray-700 text-left py-2 px-1" v-model="form.password" :max-length="6" />
            </div>
            <div class="col-span-3 text-sm pt-6">
                <jet-label for="form.password" value="Regras para a criação do PIN" />
                <i v-if="validatePassword('length')" class="fas fa-check text-green-500" />
                <i v-if="!validatePassword('length')" class="fas fa-ban text-red-500" />
                Deve ter 6 digitos<br />

                <i v-if="validatePassword('number')" class="fas fa-check text-green-500" />
                <i v-if="!validatePassword('number')" class="fas fa-ban text-red-500" />
                Deve conter apenas números<br />

                <i v-if="validatePassword('equal')" class="fas fa-check text-green-500" />
                <i v-if="!validatePassword('equal')" class="fas fa-ban text-red-500" />
                As senhas devem ser iguais<br />

            </div>
            <div class="col-span-3">
                <jet-label for="password_confirmation" value="Confirme o novo PIN" />
                <jet-input id="password_confirmation" type="password" class=" w-3/4 form-input rounded-md border border-solid border-black text-gray-700 text-left py-2 px-1" v-model="form.password_confirmation" autocomplete="new-password" />
                <jet-input-error :message="form.error('password_confirmation')" class="mt-2" />
            </div>

        </template>

        <template #actions>
            <jet-action-message :on="form.recentlySuccessful" class="mr-3">
                Salvo
            </jet-action-message>

            <jet-button @click.native="checkPasswords">
                Salvar
            </jet-button>
        </template>
    </jet-form-section>
    <jet-confirmation-modal :show="showCodeModal" @close="showCodeModal=false">
        <template #title>
           Autorização
        </template>

        <template #content>
            <jet-form-section class="items-center">
                <template #title>
                    Código de autorização
                </template>

                <template #description>
                    Informe o código de autorização para autenticar sua solicitação
                </template>

                <template #form class=" gap-0">
                    <div class="col-span-6 sm:col-span-6 my-10">
                        <jet-label for="google_2facode" value="Código de Autorização" />
                        <jet-input id="google_2facode" type="number" class="mt-1 block w-full" v-model="form.google_code" />
                        <jet-input-error :message="form.error('google_code')" class="mt-2" />
                    </div>
                </template>
            </jet-form-section>
        </template>

        <template #footer>
            <jet-secondary-button @click.native="showCodeModal = false;">
                Agora não
            </jet-secondary-button>

            <jet-ok-button class="ml-2" @click.native="save()" :class="{ 'opacity-25': form.processing }" :disabled="form.processing">
                Confirmar
            </jet-ok-button>
        </template>
    </jet-confirmation-modal>
</div>
</template>

<script>
import JetActionMessage from './../../Jetstream/ActionMessage'
import JetButton from './../../Jetstream/Button'
import JetFormSection from './../../Jetstream/FormSection'
import JetInput from './../../Jetstream/Input'
import JetInputError from './../../Jetstream/InputError'
import JetLabel from './../../Jetstream/Label'
import AppLayout from './../../Layouts/AppLayout'
import JetActionSection from './../../Jetstream/ActionSection'
import JetSectionBorder from './../../Jetstream/SectionBorder'
import JetDangerButton from './../../Jetstream/DangerButton'
import JetConfirmationModal from "./../../Jetstream/ConfirmationModal"
import JetTextarea from "../../Jetstream/Textarea"
import JetProtectedTextarea from "../../Jetstream/ProtectedTextarea"
import JetAutoComplete from "../../Jetstream/AutoComplete"
import JetSecondaryButton from "../../Jetstream/SecondaryButton"
import JetMaskedInput from "../../Jetstream/MaskedInput"
import JetFetchDoc from "../../Jetstream/FetchDoc"
import Flash from "../../Helpers/Flash"
import moment from 'moment/dist/moment'
import JetOkButton from "../../Jetstream/OkButton";
export default {
    props: ['user'],
    data() {
        return {
            showCodeModal: false,
            form: this.$inertia.form({
                _method: 'PUT',
                password: null,
                password_confirmation: null,
                google_code: null
            }, {
                resetOnSuccess: false,
            }),
        }
    },

    methods: {
        checkPasswords(){
            if (!this.validatePassword('length') || !this.validatePassword('number')){
                this.$toast.open({
                    message: 'O PIN precisa seguir os requisitos informados.',
                    type: 'warning',
                    duration: 5000,
                    position: 'top-right'
                });
                return false;
            }
            window.scrollTo(0,0);
            this.showCodeModal = true;
        },
        validatePassword: function (test) {
            if (!this.form.password) {
                return false;
            }
            switch (test) {
                case 'length':
                    return this.form.password.length == 6;
                case 'number':
                    return /(?=[0-9])/.test(this.form.password);
                case 'equal':
                    return this.form.password === this.form.password_confirmation;
            }
        },
        save: function () {
            const endpoint = `/mobilebank/${this.user.id}`;
            this.form.post(endpoint, {
                preserveScroll: true,
                onSuccess: () => {
                    this.form.processing = false
                    this.showCodeModal = false;
                    this.form.password = null;
                    this.form.password_confirmation = null;
                },
                onError: () => {
                    this.form.processing = false;
                    this.showCodeModal = false;
                }
            });
        },
    },
    components: {
        AppLayout,
        Flash,
        JetAutoComplete,
        JetSectionBorder,
        JetActionMessage,
        JetActionSection,
        JetDangerButton,
        JetConfirmationModal,
        JetButton,
        JetFormSection,
        JetInput,
        JetTextarea,
        JetProtectedTextarea,
        JetInputError,
        JetLabel,
        JetSecondaryButton,
        JetMaskedInput,
        JetFetchDoc,
        JetOkButton
    },
}
</script>
